import * as React from "react";
import { forwardRef } from "react";
const SvgTooltipTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 7, viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.4 1.13333C5.2 0.0666671 6.8 0.0666668 7.6 1.13333L12 7H0L4.4 1.13333Z", fill: "#0D0E0E" }));
const ForwardRef = forwardRef(SvgTooltipTriangle);
export { ForwardRef as ReactComponent };
